import React from 'react';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import Home from './pages/Home';
import {
  AuthenticationContext,
  AuthenticationProvider,
} from './providers/AuthenticationProvider';
import { HomeProvider } from './providers/HomeProvider';
import { ProjectProvider } from './providers/ProjectProvider';
import Project from './pages/Project';
import { RecoilRoot } from 'recoil';
import { UsersProvider } from './providers/UsersProvider';
import Users from './pages/Users';
import { useDragDrop } from '@performant-software/shared-components';
import { ActionCableProvider } from './providers/ActionCableProvider';
import LoadingSpinner from './components/LoadingSpinner';

const App = () => {
  return (
    <RecoilRoot>
      <AuthenticationProvider>
        <AuthenticationContext.Consumer>
          {({ isAuthenticated }) => {
            if (isAuthenticated()) {
              return (
                <ActionCableProvider>
                  <Router>
                    <Routes>
                      <Route
                        path="/"
                        element={
                          <HomeProvider>
                            <LoadingSpinner/>
                            <Home />
                          </HomeProvider>
                        }
                      />
                      <Route
                        path="/project/:id"
                        element={
                          <ProjectProvider>
                            <LoadingSpinner/>
                            <Project />
                          </ProjectProvider>
                        }
                      />
                      <Route
                        path="/project/:id/:tab"
                        element={
                          <ProjectProvider>
                            <LoadingSpinner/>
                            <Project />
                          </ProjectProvider>
                        }
                      />
                      <Route
                        path="/project/:id/:tab/:parentId/:childId"
                        element={
                          <ProjectProvider>
                            <LoadingSpinner/>
                            <Project />
                          </ProjectProvider>
                        }
                      />
                      <Route
                        path="/project/:id/:tab/:parentId"
                        element={
                          <ProjectProvider>
                            <LoadingSpinner/>
                            <Project />
                          </ProjectProvider>
                        }
                      />
                      <Route
                        path="/users"
                        element={
                          <UsersProvider>
                            <LoadingSpinner/>
                            <Users />
                          </UsersProvider>
                        }
                      />
                      <Route
                        path="/login"
                        element={
                          <HomeProvider>
                            <LoadingSpinner/>
                            <Home />
                          </HomeProvider>
                        }
                      />
                    </Routes>
                  </Router>
                </ActionCableProvider>
              );
            } else {
              return (
                <Router>
                  <Routes>
                    <Route
                      path="/login"
                      element={
                        <HomeProvider>
                          <LoadingSpinner/>
                          <Home />
                        </HomeProvider>
                      }
                    />
                    <Route
                      path="*"
                      element={
                        <HomeProvider>
                          <LoadingSpinner/>
                          <Home />
                        </HomeProvider>
                      }
                    />
                  </Routes>
                </Router>
              );
            }
          }}
        </AuthenticationContext.Consumer>
      </AuthenticationProvider>
    </RecoilRoot>
  );
};

// eslint-disable-next-line react-hooks/rules-of-hooks
export default useDragDrop(App);
